<template>
	<div>
		<h1 class="vrnu-headline">Benutzer</h1>
    <vrnu-text-box v-bind:variant="'info'">
      Über die Systembenutzerverwaltung können alle im System registrierten Benutzer bearbeitet werden.
      Auch können hier neue Benutzer angelegt und existierende Benutzer gelöscht oder gesperrt werden.
      Bitte beachten Sie, dass Sie aus Sicherheitsgründen kurzzeitig automatisch ausgeloggt werden, wenn Sie Ihr eigenes Profil bearbeiten
      und speichern. Sie müssen sich anschließend wieder neu einloggen.
    </vrnu-text-box>
    <vrnu-list-wizard 	v-bind:listData="listData"
							v-on:delete="deleteUser"
							v-on:saveSuccess="saveSuccess"
							v-on:saveError="saveError"></vrnu-list-wizard>
							
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
import ListWizard from '@/components/99_wizards/ListWizard';

export default {
	data: function() {
		return {
			users: [],
			infoModalMessage: null,
			listData: {
				name: "Benutzer",
				confirmAttribute: 'email',
				formModule: 'vrnu-users-form',
				viewModule: 'vrnu-users-view',
				target: 'users',
				pagination: true,
				filter: true,
				fields: [
					{
						key: 'firstname',
						label: 'Vorname',
						sortable: true						
					},
					{
						key: 'lastname',
						label: 'Nachname',
						sortable: true						
					},
					{
						key: 'role',
						label: 'Rolle',
						sortable: true,
						formatter: function(value) {
								switch(value) {
							    case 'user':
							        return "Standardbenutzer";
							        break;
							    case 'admin':
							        return "Administrator";
							        break;
							    case 'superadmin':
							        return "Superadministrator";
							        break;
							    case 'support':
							        return "Supportmitarbeiter";
							        break;
							}
						},
					},
					{
						key: 'email',
						label: 'eMail-Adresse',
						sortable: true						
					},
					{
						key: 'active',
						label: 'Aktiv',
						sortabel: true,
						formatter: function(value) { return (value == true) ? ("Ja") : ("Nein")},
					},
				],
				actions: [
					{
						type: 'view',
						text: 'Benutzer öffnen',
						icon: 'icon-eye',
					},
					{
						type: 'update',
						text: 'Benutzer bearbeiten',
						icon: 'icon-pencil',
					},
					{
						type: 'delete',
						text: 'Benutzer löschen',
						icon: 'icon-trash',
						// target: '/user/deleteUserManually/{id}',
					},
				],
			},
		};
	},
	methods: {
		getUsers: function() {
			// Get users from server
			this.$http.get('users').then(users => {
				this.users = users.body;
			}, response => {
				// TODO: find solution
				// this.users = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		deleteUser: function(id) {
			// Get users from server
			this.$http.delete('users/' + id).then(response => {
				var userName = response.body.firstname + ' ' + response.body.lastname;
				this.openInfoModal("Der Benutzer \"" + userName + "\" wurde erfolgreich gelöscht.");
			}, response => {
				this.openInfoModal("Beim Löschen des Benutzers ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});
		},
		saveSuccess: function(result) {
			this.openInfoModal("Der Benutzer \"" + result.body.firstname + " " + result.body.lastname + "\" wurde erfolgreich gespeichert.");
		},
		saveError: function(response) {
			this.openInfoModal("Beim Speichern des Benutzers ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
	},
	created: function() {
		// Get users from server and display them
		this.getUsers();
	},
	components: {
		'vrnu-list-wizard': ListWizard,
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/07_user/Users.vue